const initialState ={
    AllVideogames: [],
    videogames: [],
    genres:[],
    platform: [],
    videogameID:[],
    informacionDb: [],
};

function rootReducer(state=initialState, action) {
    switch (action.type) {
     /*    me traigo y guardo todos los videojuegos, tambien un respaldo el filtrado */
        case "GET_GAMES":
            return{
                ...state,
                AllVideogames: action.payload,
                videogames:action.payload,
            }
        /*   todos los generos  */
        case "GET_ALL_GENRES":
            return {
              ...state,
              genres: action.payload,
            };    
       /*  todas las plataformas */
        case "GET_ALL_PLATFORMS":
            return {
                ...state,
                platform: action.payload
            }

            /* ordenamos por A-Z y Z-A */
            case "ORDER_BY_NAME":
                              
                const ordenarName = action.payload === "asc" ?    state.videogames.sort((a, b)=>{
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                    return 0;
                }): state.videogames.sort((a, b)=>{
                    if (a.name > b.name) return -1;
                    if (a.name < b.name) return 1;
                    return 0;
                })
                return{
                    ...state,
                    videogames: action.payload ==='all'? state.videogames: ordenarName
                }

            /*  ordenamos por rating, min y max */
            case "ORDER_BY_RATING":    
            const sortedRating = action.payload ==="asc"
            ? state.videogames.sort(function(a,b){
                if(a.rating > b.rating) {return 1;}
                if(b.rating > a.rating){ return -1;}
                return 0
            }):
            state.videogames.sort(function(a,b){
                if(a.rating > b.rating){ return -1;}
                if(b.rating > a.rating){ return 1;}
                return 0
            })  
            return{
                ...state,
                videogames: action.payload ==='all'? state.videogames: sortedRating
            }

             /*    filtro de genero */
            case "FILTER_BY_GENRE":
                const allGames = state.AllVideogames;
                const genresFiltered =
                action.payload === "all"
                ? allGames : allGames.filter((el) =>
                el.genres.some((ele) => ele.name === action.payload)
                );
                return {
                    ...state,
                    videogames: genresFiltered,
                };

             /*  filtro para los videojuegos creados */
            case "FILTER_CREATED":    
                const allGames2 = state.AllVideogames;
                const filterCreated = 
                action.payload === 'created' 
                ? allGames2.filter(element => element.createdInDb === true) 
                : action.payload === 'all'
                ?allGames2 
                :allGames2.filter(element => element.createdInDb === false)
                return {
                    ...state,
                    videogames: filterCreated
                }

            case "GET_GAMES_BY_NAME":
                return{
                    ...state,
                    videogames: action.payload
                }    

            case "POST_VIDEOGAMES":
                return{
                    ...state,
                }

            case "GET_ID":
                return{
                    ...state,
                    videogameID: action.payload,
                }

            case "RESET_ID":
                return{
                    ...state,
                    videogameID:[],
                    videogames: [],
                }

            case "ORDER_NAME":
                return{
                    ...state,
                    videogames: action.payload
                }

            case "DELETE_GAME":
                return{
                    ...state,
                    videogames: action.payload
                }
            

            case "INFO_DB":
                return{
                    ...state,
                    informacionDb: action.payload
                }
    default: return state;    
    }
}

export default rootReducer;